var close = "Fermer";
var strings = {
	close: close
};

export { close, strings as default };
//# sourceMappingURL=strings.json.js.map
